export default __webpack_public_path__ + "static/media/B52_3.982e32ba.webp";